module.exports = __webpack_public_path__ + "static/media/not-payed.abdc1f08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/not-payed.svg
// module id = 119
// module chunks = 0